export default __webpack_public_path__ + "static/media/MapProduct.91666f2e.svg";